import React from "react";

export const WhatsAppIcon = ({width="32", height="32"}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_263_127)">
        <path
          d="M0.677557 15.8086C0.676812 18.4972 1.37932 21.1224 2.71514 23.4363L0.549805 31.3423L8.6406 29.2209C10.8784 30.4391 13.3857 31.0775 15.9336 31.0776H15.9403C24.3515 31.0776 31.1984 24.2332 31.202 15.8206C31.2036 11.7441 29.6175 7.91076 26.7357 5.02679C23.8545 2.14307 20.0225 0.554107 15.9397 0.552246C7.52754 0.552246 0.681154 7.39628 0.677681 15.8086"
          fill="url(#paint0_linear_263_127)"
        />
       
        <path
          d="M11.991 9.19662C11.6951 8.53888 11.3837 8.52561 11.1022 8.51407C10.8718 8.50415 10.6083 8.5049 10.3451 8.5049C10.0817 8.5049 9.65368 8.604 9.29188 8.99904C8.92971 9.39445 7.90918 10.35 7.90918 12.2934C7.90918 14.2369 9.32475 16.1152 9.52208 16.379C9.71966 16.6423 12.2549 20.7582 16.27 22.3415C19.6069 23.6574 20.286 23.3957 21.0102 23.3297C21.7345 23.264 23.3474 22.3744 23.6765 21.452C24.0058 20.5297 24.0058 19.7391 23.9071 19.5739C23.8083 19.4093 23.5449 19.3105 23.1499 19.113C22.7548 18.9156 20.8126 17.9598 20.4506 17.8279C20.0884 17.6962 19.8251 17.6305 19.5616 18.026C19.2982 18.4209 18.5417 19.3105 18.3112 19.5739C18.0808 19.838 17.8503 19.8708 17.4553 19.6733C17.0601 19.4751 15.7879 19.0584 14.2785 17.7128C13.1042 16.6658 12.3114 15.3727 12.081 14.9772C11.8505 14.5823 12.0563 14.3682 12.2544 14.1714C12.4318 13.9944 12.6495 13.7101 12.8472 13.4795C13.0442 13.2488 13.1099 13.0842 13.2416 12.8208C13.3735 12.5571 13.3075 12.3264 13.2089 12.1288C13.1099 11.9313 12.3423 9.97764 11.991 9.19662Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_263_127"
          x1="1533.16"
          y1="3079.56"
          x2="1533.16"
          y2="0.552246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FAF38" />
          <stop offset="1" stop-color="#60D669" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_263_127"
          x1="1587.6"
          y1="3189.42"
          x2="1587.6"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F9F9F9" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <clipPath id="clip0_263_127">
          <rect width="31.7519" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
